import { useEffect, useState } from "react";
import { ConfirmDialog } from "../common/ConfirmDialog";

// Store de módulo: backdrop.ts (sem React) pede o prompt; o host (montado uma
// vez no __root) renderiza. ponytail: um único prompt global basta.
let listener: ((run: (() => void) | null) => void) | null = null;
export function askDiscard(run: () => void) { listener?.(run); }

export function DiscardPromptHost() {
  const [pending, setPending] = useState<(() => void) | null>(null);
  useEffect(() => { listener = setPending; return () => { listener = null; }; }, []);
  if (!pending) return null;
  return (
    <ConfirmDialog
      title="Descartar alterações?"
      message="Há modificações não salvas nesta janela."
      confirmLabel="Descartar"
      danger
      onConfirm={() => { const r = pending; setPending(null); r(); }}
      onCancel={() => setPending(null)}
    />
  );
}
